import { Form, Grid } from "antd";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useGetSingleDestinationQuery } from "src/store/apis/pointsExchange";
import NoData from "@Components/NoData/NoData";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import PointsExchangeWeb from "./layouts/PointsExchange.web";
import PointsExchangeMob from "./layouts/PointsExchange.mob";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { getDestinationProgramData } from "./utils";
import { useForm } from "antd/es/form/Form";
import { ExchangeDetailsHeader, PointsExchangeSkeleton } from "./components";

const PointsExchangeComponent = withConditionalComponent(PointsExchangeWeb, PointsExchangeMob);

export default function ProgramExchangeNew() {
  const { t, i18n } = useTranslation();
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  const { code } = useParams();
  const { data, isFetching, error } = useGetSingleDestinationQuery({ page: 1, pageSize: 10000, lang: i18n.language, code });
  const form = useForm()?.[0];

  const program = data?.[0];
  const hasError = !isFetching && (!!error || !program);
  const programData = !isFetching && program ? getDestinationProgramData(program) : undefined;

  return (
    <div className="font-inter bg-background-default flex w-full flex-1 flex-col items-start gap-5 p-6 md:p-10">
      <ExchangeDetailsHeader programName={programData?.destinationProgram?.name} isFetching={isFetching} />
      {isFetching && (
        <div className="flex w-full flex-1 items-start justify-center md:p-5">
          <PointsExchangeSkeleton />
        </div>
      )}
      {hasError && (
        <div className="flex w-full flex-1 items-center justify-center">
          <NoData description={t("PointsExchange.exchange.detailsUnavailable")} className="h-full w-full" />
        </div>
      )}
      {programData && (
        <div className="flex w-full flex-1 items-start justify-center md:p-5">
          <Form form={form} layout="vertical" className="w-full">
            <PointsExchangeComponent props={{ ...programData, loading: isFetching, error }} trigger={isLargeScreen} />
          </Form>
        </div>
      )}
    </div>
  );
}
